// eslint-disable-next-line import/named
import { isNil } from 'ramda';

const VIDEO_PLAYERS = {
  YOUTUBE: 'youtube',
  VIMEO: 'vimeo',
  WISTIA: 'wistia',
};

const VIDEO_REGEXPS = {
  [VIDEO_PLAYERS.YOUTUBE]: [
    /^(?:https?:\/\/|\/\/)?(?:www\.)?youtube\.com\/watch\?v=([A-Za-z\d._%-]+)(?:&\S+)?/,
    /^(?:https?:\/\/|\/\/)?(?:www\.)?youtu\.be\/([A-Za-z\d._%-]+)/,
    /^(?:https?:\/\/|\/\/)?(?:www\.)?youtube\.googleapis\.com\/v\/([A-Za-z\d._%-]+)/,
    /^(?:https?:\/\/|\/\/)?(?:www\.)?youtube\.com\/shorts\/([A-Za-z\d._%-]+)(\?si=([A-Za-z\d._%-]+))?(?:&\S+)?/,
  ],
  [VIDEO_PLAYERS.VIMEO]: [
    /^(?:https?:\/\/|\/\/)?(?:www\.)?vimeo\.com\/(\d+)(?:\/([A-Za-z\d]+))?/,
    /^(?:https?:\/\/|\/\/)?(?:www\.)?player\.vimeo\.com\/video\/(\d+)(?:\?h=([A-Za-z\d]+))?/,
  ],
  [VIDEO_PLAYERS.WISTIA]: [
    /^(?:https?:\/\/|\/\/)?(?:www\.)?fast\.wistia\.net\/embed\/iframe\/([A-Za-z\d._%-]+)/,
    /^(?:https?:\/\/|\/\/)?(?:www\.)?(?:[A-Za-z\d-]+)\.wistia\.com\/medias\/([A-Za-z\d._%-]+)/,
  ],
};

function parseVideoUrl(url: string = '') {
  // - Supported YouTube URL formats:
  //   - http://www.youtube.com/watch?v=My2FRPA3Gf8
  //   - http://youtu.be/My2FRPA3Gf8
  //   - http://youtu.be/dDeWWQWMM-Y?t=3973
  //   - http://youtube.googleapis.com/v/My2FRPA3Gf8
  //   - http://youtube.com/shorts/u2TUPw3yCOo
  // - Supported Vimeo URL formats:
  //   - http://vimeo.com/25451551
  //   - http://vimeo.com/654719032/af97f2cd8f
  //   - http://player.vimeo.com/video/25451551
  //   - http://player.vimeo.com/video/654719032?h=af97f2cd8f
  // - Also supports relative URLs:
  //   - //player.vimeo.com/video/25451551
  // - Supported Wistia URL formats:
  //   - http://fast.wistia.net/embed/iframe/avk9twrrbn
  //   - http://jetrockets.wistia.com/medias/aulnm4xu9r
  url = url.trim();

  for (let i = 0; i < VIDEO_REGEXPS[VIDEO_PLAYERS.YOUTUBE].length; i++) {
    const match = url.match(VIDEO_REGEXPS[VIDEO_PLAYERS.YOUTUBE][i]);
    if (match && match[1]) {
      return `//www.youtube.com/embed/${match[1]}`;
    }
  }

  for (let i = 0; i < VIDEO_REGEXPS[VIDEO_PLAYERS.VIMEO].length; i++) {
    const match = url.match(VIDEO_REGEXPS[VIDEO_PLAYERS.VIMEO][i]);
    if (match && match[1]) {
      return `//player.vimeo.com/video/${match[1]}${match[2] ? `?h=${match[2]}` : ''}`;
    }
  }

  for (let i = 0; i < VIDEO_REGEXPS[VIDEO_PLAYERS.WISTIA].length; i++) {
    const match = url.match(VIDEO_REGEXPS[VIDEO_PLAYERS.WISTIA][i]);
    if (match && match[1]) {
      return `//fast.wistia.net/embed/iframe/${match[1]}`;
    }
  }

  return null;
}

export function isValidVideoUrl(url: string) {
  return !isNil(parseVideoUrl(url));
}

export default parseVideoUrl;
